module.exports = __webpack_public_path__ + "static/media/imagotipo2.b6de1f20.svg";